/* eslint max-statements: 0 */
import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { FormattedDistance } from 'shared/units'
import { FormattedDuration } from 'shared/units'
import { FormattedEnergy } from 'shared/units'
import { FormattedPace } from 'shared/units'
import { LONG, METERS_PER_SECOND } from 'shared/units/constants'
import Svg from 'components/util/Svg'
import leaf from 'images/leaf.png'
import styles from './_highlight.css'

export function Highlight ({ highlight, value, numOfHighlights }) {
  let component = null
  let title = null
  let icon = null
  const thumbSize = numOfHighlights === 3 ? '183x156' : '274x156'

  if (highlight.key === 'energy_burned') {
    component = <FormattedEnergy from='joules' value={value} digits={0} />
    title = <FormattedMessage id='feed.story.energy' defaultMessage='Energy Burned' />
    icon = 'stat_calories'
  }

  if (highlight.key === 'distance') {
    component = <FormattedDistance value={value} digits={2} />
    title = <FormattedMessage id='feed.story.distance' defaultMessage='Distance' />
    icon = 'stat_distance'
  }

  if (highlight.key === 'duration') {
    component = <FormattedDuration value={value} unit={LONG} />
    title = <FormattedMessage id='feed.story.duration' defaultMessage='Duration' />
    icon = 'stat_duration'
  }

  if (highlight.key === 'route') {
    component = <img className={styles.thumb} src={`${highlight.thumbnail_url}?size=${thumbSize}`} />
  }

  if (highlight.key === 'avg_pace') {
    component = <FormattedPace value={1 / value} from={METERS_PER_SECOND} clockDisplay={true} digits={1} />
    title = <FormattedMessage id='feed.story.pace' defaultMessage='Avg Pace' />
    icon = 'stat_pace_speed'
  }

  return (
    <div className={classnames(styles.container, {
      [styles.thumbContainer]: highlight.key === 'route',
    })}>
      {highlight.percentile ?
        <div className={classnames(styles.percentile, styles[highlight.key])}>
          <FormattedMessage
            id='feed.story.percentile'
            defaultMessage='Top {percentile}%'
            values={{
              percentile: highlight.percentile,
            }}
          />
        </div>
      : null}
      {icon ? <Svg name={icon} className={styles.icon} /> : null}
      {title ?
        <div className={styles.title}>
          {title}
          {highlight.percentile ? <img className={styles.leaf} src={leaf} /> : null}
        </div>
      : null}
      {component}
    </div>
  )
}

Highlight.propTypes = {
  highlight: PropTypes.object,
  value: PropTypes.number,
  numOfHighlights: PropTypes.number,
}

export default Highlight



// WEBPACK FOOTER //
// ./src/components/home/feed/Highlight.jsx